import { css } from "@emotion/react";
import { borders } from "aviary-tokens";

export const shopMenuDropdown = css`
  box-shadow: none;
  overflow: visible;
  margin-top: 0 !important;
  background: transparent;
  padding: 0.5rem 0 0;
  &::after {
    content: unset;
  }
`;

export const shopMenuDropdownContent = css`
  border-radius: ${borders.radiusBase};
  box-shadow: 0px 4px 16px 0px #36485c29;
  position: relative;
  z-index: 1;
`;
